import * as React from 'react';
import { Text } from 'ui';
import { i18n } from 'i18n';
import config from 'config';
import { prefixClassName } from 'framework/components/ui/_conf';
import { SelectPrimitive } from '../../FormComponents/Primitives';
import { SelectMenuPlacements } from '../../FormComponents/Select/interfaces';

const clx = prefixClassName('paginationButtons');

export interface IPageSizeSelector {
  pageSize: number;
  onSetPageSizeHandler: (e?: any) => void;
  className?: string;
}

export const PageSizeSelector: React.FC<IPageSizeSelector> = ({
  pageSize,
  onSetPageSizeHandler,
  className,
}) => {
  return (
    <div className={`${clx}__pagesize ${className}`}>
      <Text
        tag="span"
        className={`${clx}__pagesize-select__label`}
        caption="components.pagination.buttons.pageSizeLabel"
      />
      <SelectPrimitive
        name="page_size"
        clearable={false}
        className={`${clx}__pagesize-select`}
        value={pageSize.toString()}
        options={config.dataGridPageSizeOptions.map((item) => ({
          label: i18n.t('components.pagination.buttons.pageSize', { size: item }) as string,
          value: item,
        }))}
        onChange={onSetPageSizeHandler}
        menuPlacement={SelectMenuPlacements.Auto}
      />
    </div>
  );
};

export default PageSizeSelector; 